<div class="agent-pills-container" *ngIf="pills && pills.length > 0">
  <div class="agent-pills-list">
    <button 
      *ngFor="let pill of pills; let i = index"
      class="agent-pill-btn"
      [class.disabled]="isDisabled"
      (click)="onPillClick(pill)"
      [id]="idPrefix + '_' + i"
      [attr.aria-label]="pill">
      {{ pill }}
    </button>
  </div>
</div>

